import React, { useEffect, useState } from 'react';
import axios from '../axiosInstance';
import HCaptcha from '@hcaptcha/react-hcaptcha';

const Submit = () => {
  const [imageUrl, setImageUrl] = useState('');
  const [targetUrl, setTargetUrl] = useState('');
  const [description, setDescription] = useState('');
  const [shareLink, setShareLink] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [hcaptchaToken, setHcaptchaToken] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const isValidUrl = (url) => {
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setShareLink('');

    if (!imageUrl || !targetUrl || !description) {
      setError('All fields are required.');
      return;
    }

    if (!isValidUrl(imageUrl) || !isValidUrl(targetUrl)) {
      setError('Please enter valid URLs.');
      return;
    }

    if (!hcaptchaToken) {
      setError('Please complete the hCaptcha challenge.');
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post(`/api/banners/submit`, {
        recaptchaToken: hcaptchaToken,
        image_url: imageUrl,
        target_url: targetUrl,
        description: description
      });

      setShareLink(res.data.shareUrl);
      setImageUrl('');
      setTargetUrl('');
      setDescription('');
      setHcaptchaToken('');
    } catch (err) {
      console.error(err);
      setError('An error occurred while submitting your banner.');
    } finally {
      setLoading(false);
    }
  };

   // === NOUVEAU AADS ADAPTATIF (mobile + desktop) ===
useEffect(() => {
  const div = document.createElement("div");
  div.innerHTML = `
    <!-- BEGIN AADS AD UNIT 2425494 -->
   
    <!-- END AADS AD UNIT 2425494 -->
  `;
  document.body.appendChild(div);
  return () => document.body.removeChild(div);
}, []);

  return (
    <div className="min-h-screen bg-gray-950 text-gray-100 font-sans overflow-hidden">
      {/* NAVBAR - exact same as Home & Leaderboard */}
      <header className="bg-gray-900/95 backdrop-blur-xl border-b border-gray-800 sticky top-0 z-50">
        <div className="max-w-7xl 2xl:max-w-none mx-auto px-4 sm:px-6 2xl:px-10 py-4 sm:py-5">
          <div className="flex items-center justify-between">
            
            {/* Logo + Hamburger (visible seulement mobile) */}
            <div className="flex items-center gap-4">
              <img 
                src="/bannerRank.png" 
                alt="RankMyBanner" 
                className="h-9 sm:h-10 w-auto drop-shadow-[0_0_15px_rgb(16,185,129)]" 
              />
              
              {/* Hamburger - visible < md */}
              <button 
                type="button" 
                className="md:hidden text-emerald-400 focus:outline-none"
                aria-label="Toggle menu"
                onClick={() => setIsOpen(!isOpen)}
              >
                {/* SVG hamburger ou croix selon isOpen */}
                  {isOpen ? (
                    <svg className="h-8 w-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  ) : (
                    <svg className="h-8 w-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                    </svg>
                  )}
              </button>
            </div>

            {/* Navigation */}
            <nav
                  className={`
                    ${isOpen ? 'block' : 'hidden'}              // affiche/cache sur mobile quand on clique
                    md:flex md:items-center                     // sur desktop → toujours visible + flex horizontal
                    absolute md:static top-full left-0 right-0  // position absolute sur mobile pour dropdown
                    bg-gray-900/95 md:bg-transparent            // fond sombre sur mobile, transparent sur desktop
                    border-b border-gray-800 md:border-none     // bordure basse sur mobile uniquement
                    p-6 md:p-0                                  // padding plus important sur mobile
                    flex flex-col md:flex-row                   // colonne sur mobile, ligne sur desktop
                    gap-6 md:gap-x-8 md:gap-y-0                 // espacement adapté
                    text-sm font-medium                         // style texte
                    z-40                                        // au-dessus du reste si besoin
                  `}
                >
              <a href="/" className="hover:text-emerald-400 transition hover:text-emerald-300">Home</a>
              <a href="/leaderboard" className="hover:text-emerald-400 font-semibold transition">Leaderboard</a>
              <a href="/submit" className="text-emerald-400 transition">Submit Your Banner</a>
              <a href="/claim" className="hover:text-emerald-400 transition">Claim Points</a>
              <a href="/how-to-increase" className="hover:text-emerald-400 transition">How to Increase</a>
            </nav>

            {/* Pub – cachée sur < 2xl */}
            <div className="hidden 2xl:block flex-shrink-0">
              <iframe 
                src="https://zerads.com/ad/ad.php?width=728&ref=10558" 
                width="728" 
                height="90" 
                scrolling="no" 
                border="0" 
                frameBorder="0"
              />
            </div>
          </div>
        </div>
      </header>

      {/* SUBMIT SECTION - cyber neon style */}
      <section className="py-24 bg-black relative">
        <div className="max-w-2xl mx-auto px-6">
          {/* Header */}
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-3 bg-emerald-500/10 border border-emerald-500/30 px-8 py-3 rounded-3xl text-emerald-400 font-medium mb-6 shadow-[0_0_30px_rgb(16,185,129,0.3)]">
              <div className="w-3 h-3 bg-emerald-400 rounded-full animate-pulse" /> 
              GET INSTANT TRAFFIC
            </div>
            <h1 className="text-6xl md:text-7xl font-black tracking-[-3px] leading-none mb-4 bg-clip-text text-transparent bg-gradient-to-r from-white via-emerald-200 to-teal-300">
              SUBMIT YOUR BANNER
            </h1>
            <p className="text-2xl text-gray-400 max-w-lg mx-auto">
              Takes 30 seconds. Gets you real traffic forever.
            </p>
          </div>

          {/* FORM CARD */}
          <div className="bg-gray-900 border border-gray-800 rounded-3xl p-10 shadow-2xl backdrop-blur-xl">
            <form onSubmit={handleSubmit} className="space-y-8">
              {error && (
                <div className="bg-red-950 border border-red-500 text-red-400 px-6 py-4 rounded-2xl text-sm">
                  {error}
                </div>
              )}

              <div>
                <label className="block text-emerald-400 font-medium mb-2 text-sm tracking-widest">BANNER IMAGE URL</label>
                <input
                  type="text"
                  value={imageUrl}
                  onChange={(e) => setImageUrl(e.target.value)}
                  placeholder="https://example.com/your-banner.png"
                  className="w-full bg-gray-950 border border-gray-700 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500/50 rounded-2xl px-6 py-4 text-white placeholder-gray-500 transition-all"
                  required
                />
              </div>

              <div>
                <label className="block text-emerald-400 font-medium mb-2 text-sm tracking-widest">TARGET URL (WHERE VISITORS GO)</label>
                <input
                  type="text"
                  value={targetUrl}
                  onChange={(e) => setTargetUrl(e.target.value)}
                  placeholder="https://yourwebsite.com"
                  className="w-full bg-gray-950 border border-gray-700 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500/50 rounded-2xl px-6 py-4 text-white placeholder-gray-500 transition-all"
                  required
                />
              </div>

              <div>
                <label className="block text-emerald-400 font-medium mb-2 text-sm tracking-widest">DESCRIPTION</label>
                <textarea
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Short catchy description of your banner..."
                  className="w-full bg-gray-950 border border-gray-700 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500/50 rounded-2xl px-6 py-4 text-white placeholder-gray-500 transition-all resize-y min-h-[100px]"
                  rows={4}
                  required
                />
              </div>

              {/* hCaptcha - dark theme */}
              <div className="flex justify-center pt-4">
                <HCaptcha
                  sitekey="dd701b24-dc2c-4252-a48c-114639bec116"
                  onVerify={token => setHcaptchaToken(token)}
                  onExpire={() => setHcaptchaToken('')}
                  theme="dark"
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full py-6 bg-gradient-to-r from-emerald-500 to-teal-500 text-xl font-black rounded-3xl hover:scale-105 transition-all shadow-[0_0_40px_rgb(16,185,129)] disabled:opacity-70"
              >
                {loading ? 'SUBMITTING...' : 'SUBMIT BANNER → GET YOUR LINK'}
              </button>
            </form>

            {/* SUCCESS MESSAGE */}
            {shareLink && (
              <div className="mt-10 p-8 bg-emerald-950 border border-emerald-500/30 rounded-3xl text-center">
                <div className="text-emerald-400 text-2xl font-bold mb-4">✅ BANNER SUBMITTED!</div>
                <p className="text-gray-400 mb-6">Share this unique link to start earning points instantly:</p>
                
                <div className="bg-gray-950 p-5 rounded-2xl font-mono text-emerald-300 break-all text-sm mb-6 border border-emerald-500/20">
                  {shareLink}
                </div>

                <a
                  href={shareLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block px-10 py-4 bg-emerald-500 hover:bg-emerald-600 text-black font-bold rounded-2xl transition"
                >
                  OPEN LINK
                </a>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* ZeroAds bottom banner */}
      <div className="flex justify-center py-12 bg-gray-900">
        <iframe 
          src="https://zerads.com/ad/ad.php?width=728&ref=10558" 
          width="728" height="90" scrolling="no" border="0" frameBorder="0"
        />
      </div>

      {/* FINAL CTA */}
      <div className="py-28 bg-gradient-to-r from-emerald-950 via-black to-teal-950 text-center">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="text-6xl font-black tracking-tight mb-8">ALREADY SUBMITTED?<br />WANT MORE TRAFFIC?</h2>
          <a 
            href="/leaderboard" 
            className="inline-block px-16 py-7 text-2xl font-bold bg-white text-black rounded-3xl hover:bg-emerald-400 hover:text-black transition-all scale-105 shadow-[0_0_60px_rgb(16,185,129)]"
          >
            CHECK THE LEADERBOARD →
          </a>
        </div>
      </div>

      {/* FOOTER - exact same as Home */}
      <footer className="bg-gray-950 border-t border-gray-800 py-12">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-8 text-sm text-gray-500">
            <div>© 2026 RankMyBanner • All Rights Reserved</div>
            <div className="flex gap-8">
              <a href="/" className="hover:text-gray-300">Home</a>
              <a href="/leaderboard" className="hover:text-gray-300">Leaderboard</a>
              <a href="/submit" className="hover:text-gray-300">Submit Your Banner</a>
              <a href="/claim" className="hover:text-gray-300">Claim Points</a>
              <a href="/how-to-increase" className="hover:text-gray-300">How to Increase</a>
            </div>
            
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Submit;